import { Component } from '@angular/core';
import { culturalNewsletter } from 'src/app/constant/auto/culturalnewsletter.constant';

@Component({
  selector: 'app-cultural-news',
  templateUrl: './cultural-news.html',
  styleUrls: ['./cultural-news.css'],
  standalone: false
})
export class CulturalNews {
  readonly culturalNews: typeof culturalNewsletter;
  constructor() {
    this.culturalNews = culturalNewsletter;
  }
}
